import { useEffect, useRef, useState } from 'react';
import Button from '../../components/button/Button';
import Input from '../../components/input/Input';
import TextArea from '../../components/textarea/TextArea';
import Notify from '../../methods/notify/Notify';
import Map from '../../parts/map/Map';
import './contact.css';

export default function Contact(params) {
  const [viewList, updateViewList] = useState([]);
  const mapRef = useRef();
  const [temp, setTemp] = useState(1);
  const view = (
    <h5 className="p-3 text-secondary-400 bg-primary-700">
      Unable To Proceed, Right Now
    </h5>
  );

  const handleForm = () => {
    updateViewList([...viewList, view]);
  };

  useEffect(() => {
    if (mapRef?.current?.children[0]) {
      const errorDiv = mapRef.current.children[0];
      if (errorDiv.children[1]) {
        errorDiv.children[1].style.display = 'none';
      } else {
        setTemp(temp + 1);
      }
    } else {
      setTemp(temp + 1);
    }
  }, [temp]);

  return (
    <div className="contact">
      <Notify viewList={viewList} position="bottom-left" />
      <div className="flex w-full flex-wrap items-center">
        <div className="w-full lg:w-1/2">
          <div className="heading">
            <h1 className="text-secondary-300">Contact me</h1>
          </div>

          <div className="paragraph">
            <p>
              I’m interested in physical or remote opportunities to work in
              ambitious or large scale projects with positive people.
            </p>
            <p>
              However, if you have any query or question, i'am available here
              <span
                onClick={() =>
                  window.open(
                    'https://www.linkedin.com/in/md-amanullah-sayeem-77922b18a/',
                    '_blank'
                  )
                }
              >
                LinkedIn
              </span>
              or just contact by
              <span
                onClick={() => window.open('mailto:amanullahsayeem@gmail.com')}
              >
                amanullahsayeem@gmail.com
              </span>
              .
            </p>
          </div>

          <div className=" form">
            <div className="py-3 px-16 px-auto lg:pl-12">
              <div className="grid gap-4 lg:grid-flow-col">
                <div className="customInput">
                  <Input type="text" placeholder="Name" />
                </div>
                <div className="customInput">
                  <Input type="email" placeholder="Email" />
                </div>
              </div>
              <div className="my-4 customInput">
                <Input type="text" placeholder="Subject" />
              </div>

              <div className="my-4 bg-primary-700 text-primary-400">
                <TextArea type="text" placeholder="Message" />
              </div>
              <div className="w-40 h-10 ml-auto border text-primary-50 border-secondary-200 hover:bg-secondary-300 hover:text-primary-800">
                <Button onClicked={handleForm} title="Send me message!" />
              </div>
            </div>
          </div>
        </div>
        <div
          ref={mapRef}
          className="py-4 px-6 w-full lg:w-1/2 h-80 lg:h-[500px]"
        >
          <Map />
        </div>
      </div>
    </div>
  );
}
